import React,{useEffect,useState,useMemo} from 'react';
//import Modal from '@mui/material/Modal';
//import Box from '@mui/material/Box';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
//import FormGroup from '@mui/material/FormGroup';
//import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
//import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Dialog from '@mui/material/Dialog';
//import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {EventTag} from './Inc';
import {Tools} from './Tools';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import Ajax from './Ajax';
import useStyles from './Styles';

interface EventTagSearchProps {
    close():void,
	add(tags:EventTag[]):void,
    isOpen:boolean,
	ownerId:number,
	currentTags:EventTag[],
}

const EventTagSearch = (props:EventTagSearchProps)=> {
	Ajax.setEditorId(props.ownerId);
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	const [tags,setTags] = useState({
		list:[] as EventTag[],
		error: '',
		selected: 0,
		currentTags:{} as {[id: string]:boolean;},
		ym: '',
	});
	const onCheckEventTag = (index:number) => (event: React.MouseEvent<HTMLInputElement>) => {
		let list = [...tags.list];
		//console.log(list[index]);
		//console.log(tags.currentTags);
		if( list[index].id in tags.currentTags ){
			//console.log("exists");
			return;
		}		
		list[index].selected = !list[index].selected;
		let selected = 0;
		for( let i=0; i<list.length; i++ ){
			if( list[i].selected ){
				selected++;
			}
		}
		setTags({...tags,list:list,selected:selected});
	}
	const onChangeSelect = (event: SelectChangeEvent) => {
		if (!event) {
			return;
		}
		let value = event.target.value;
		load(value);
	}
    const load = (ym:string)=>{
		const currentTags = {} as {[id: string]:boolean;};
		for( let i=0; i<props.currentTags.length; i++ ){
			currentTags[props.currentTags[i].id] = props.currentTags[i].selected;
		}
        Ajax.send("item/event_tags",{ym:ym},(res:any)=>{
            if( res.ok ){
				setTags({list:res.list,error:'',selected:0,currentTags:currentTags,ym:ym});
            } else {
				setTags({list:[],error:'見つかりませんでした',selected:0,currentTags:currentTags,ym:ym});
            }
        });
    }
	const add = ()=>{
		const selected = [] as EventTag[];
		for( let i=0; i<tags.list.length; i++ ){
			if( tags.list[i].selected ){
				selected.push(tags.list[i]);
			}
		}
		props.add(selected);
	}
	const close = ()=>{
		props.close();
	}
	const selectYm = useMemo(()=>{
		const yms = [] as string[];
		yms.push('000000')
		const today = new Date();
		const year = today.getFullYear();
		const month = today.getMonth()+1;
		let lastYear = year;
		let lastMonth = month+6;
		if( lastMonth>12 ){
			lastYear ++;
			lastMonth -= 12;
		}
		for( let y=lastYear; y>=2022; y-- ){
			for( let m=12; m>0; m-- ){
				if( y===lastYear && m>lastMonth ){
					continue;
				}
				yms.push(y+Tools.zeroPadding(String(m),2));
			}
		}
		return (
					<FormControl fullWidth={true} style={{position:'absolute',top:'0',left:'0',padding:'1em 2em',paddingBottom:'1em',boxSizing:'border-box',backgroundColor:'#F5F5F5',borderBottom:'1px solid #CCCCCC',width:'100%',zIndex:9999}}>
						<FormLabel component="label" style={{fontSize:'90%',margin:'0',padding:'0'}}>開催年月</FormLabel>
						<Select
							value={tags.ym}
							onChange={onChangeSelect}
							style={{margin:'0'}}
							variant="standard"
						>
							{yms.map((ym:string,index:number)=>{
								let label = '不明';
								if( ym!=='000000' ){
									label = ym.substring(0,4)+"年"+ym.substring(4,6)+"月";
								}
								return (
									<MenuItem value={ym} key={ym}>{label}</MenuItem>
								)
							})}							
						</Select>
					</FormControl>
		)
	},[tags.ym]);

	useEffect(()=>{
		if(!props.isOpen){
			return;
		}
		const today = new Date();
		load(today.getFullYear()+("0" + (today.getMonth()+1)).slice(-2));
	},[props.isOpen])

	if( !props.isOpen ){
		return (null);
	}
	
	return (
        <Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			scroll='paper'
			fullScreen={fullScreen}
        >
			<DialogContent dividers>
				{selectYm}
				<List dense={true} style={{marginTop:'5em',marginLeft:'0',marginRight:'0',padding:'0',minWidth:'320px'}}>
				{tags.list.length===0 &&
				<ListItem>
					<ListItemText primary="イベントが見つかりません"/>
				</ListItem>
				}
				{tags.list.map((tag:EventTag,index:number)=>{
					const key = 'tag'+index;
					let label = '';
					let labelColor = Theme.palette.primary.main;
					if( tag.admit ){
						if( tag.start ){
							label = tag.start;
							if( tag.end && tag.end!==tag.start ){
								label = label + "～" + tag.end;
							}
						} else {
							label = '開催期間未定';
						}
					} else if( tag.new ){
						label = 'NEW!';
						labelColor = Theme.palette.success.main;
					} else {
						label = '仮登録';
						labelColor = Theme.palette.info.main;
					}

					let checked = false;
					let disabled = false;
					if( tag.selected ){
						checked = true;
					} else if( tag.id in tags.currentTags ){
						checked = tags.currentTags[tag.id];
						disabled = true;
					}

					return (
						<ListItem key={key} style={{margin:'0',padding:'0'}} dense={true} button={true} disabled={disabled} onClick={onCheckEventTag(index)}>
							<ListItemIcon style={{marginRight:'0'}}>
								<Checkbox
									checked={checked}
									tabIndex={-1}
									disableRipple
									inputProps={{ 'aria-labelledby': key }}
									color="primary"
								/>
							</ListItemIcon>
							<ListItemText style={{marginLeft:'0',paddingLeft:'0'}} primary={tag.name} secondary={
								<span style={{fontSize:'90%',color:labelColor}}>{label}</span>
							}/>
						</ListItem>
					)
				})}
				</List>
				
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='追加' onClick1={add} disabled1={tags.selected===0} button2='閉じる' onClick2={close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
    );
}

export default EventTagSearch;
